import MainLayout from '@/components/layout/MainLayout'

export default function DashboardPage() {
  return (
    <MainLayout>
      <div className="space-y-6">
        <div className="border-b border-gray-200 pb-4">
          <h1 className="text-3xl font-bold text-gray-900">Dashboard</h1>
          <p className="text-gray-600">Welcome to Platform Certi</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="card p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Quick Stats
            </h3>
            <p className="text-gray-600">
              Your platform overview and metrics
            </p>
          </div>
          
          <div className="card p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Recent Activity
            </h3>
            <p className="text-gray-600">
              Latest updates and notifications
            </p>
          </div>
          
          <div className="card p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Actions
            </h3>
            <p className="text-gray-600">
              Quick actions and shortcuts
            </p>
          </div>
        </div>
      </div>
    </MainLayout>
  )
}